export { WindreamTokenHttpAuthenticationProvider } from './windreamTokenHttpAuthenticationProvider';